import { render, staticRenderFns } from "./SigninPage.vue?vue&type=template&id=38b07f36&scoped=true"
import script from "./SigninPage.vue?vue&type=script&lang=js"
export * from "./SigninPage.vue?vue&type=script&lang=js"
import style0 from "./SigninPage.vue?vue&type=style&index=0&id=38b07f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b07f36",
  null
  
)

export default component.exports